import { emptyNull } from '../../../shared/misc';

export const selectModuleList = (state) => state.appState.settings.modules ?? emptyNull;
